import authRules from '../authRules';

// TODO: Create js doc-strings for all AuthLogic modules, specifying where in the app the logic is applied

const adjustWorkTimes = (user) => {
  const { assignments, updateTourHours } = user.securityLevels;
  if (
    assignments >= authRules.adjustWorkTimes.assignments
    && updateTourHours >= authRules.adjustWorkTimes.updateTourHours
    ) {
      return true;
  } else {
      return false;
    }
  }

export default adjustWorkTimes



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/adjustWorkTimes.js